module.exports = __webpack_public_path__ + "statics/img/cate7-4@2x.e0beac99.png";